import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import registration from "./modules/registration";
import login from "./modules/login";
import profile from "./modules/profile";
import admin from "./modules/admin";
import adminsub from "./modules/adminsub";
import wckits from "./modules/wckits";
import wooAnalytics from './modules/wooAnalytics';

Vue.use(Vuex);

axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    // store.commit('loadingStop');
    return response;
  },
  function(error) {
    // Do something with response error
    if (error.response.data.error === "ValidationException") {
      store.dispatch("handleErrors", error.response.data.data.messages);
    } else if (
      error.response.data.message === "This Kit has been archived"
    ) {
      store.dispatch("handleErrors", {
        errors: [
          {
            field: "kit_id",
            message: 'This Kit has been archived'
          }
        ]
      });
    }
     else if (
      error.response.data.message === "Token is used by another user"
    ) {
      store.dispatch("handleErrors", {
        errors: [
          {
            field: "kit_id",
            message: "Kit ID already registered. Sign in!"
          }
        ]
      });
    } else if (error.response.data.error === "UserNotFoundException") {
      store.dispatch("handleErrors", {
        errors: [
          {
            field: "email",
            message: "Cannot find this email address."
          }
        ]
      });
    } else if (error.response.data.error === "PasswordMisMatchException") {
      store.dispatch("handleErrors", {
        errors: [
          {
            field: "password",
            message: "The password is not correct."
          }
        ]
      });
    } else if (error.response.data.message === "Old password incorrect") {
      store.dispatch("handleErrors", {
        errors: [
          {
            field: "old_password",
            message: "Password invalid"
          }
        ]
      });
    } else if (error.response.data.error === "error") {
      store.dispatch("handleErrors", {
        errors: [
          {
            field: "kit_dashboard",
            message: error.response.data.data.constraint
          }
        ]
      });
    } else if (error.response.data.errors) {
      if (error.response.data.errors[0].validation === "exists") {
        store.dispatch("handleErrors", {
          errors: [
            {
              field: "kit_id",
              message: "Kit ID does not exist"
            }
          ]
        });
      } else if (error.response.data.errors[0].validation === "unique") {
        store.dispatch("handleErrors", {
          errors: [
            {
              field: "email",
              message: "This Email already registered"
            }
          ]
        });
      }
    } else if (error.response.data.error === "TwilioError") {
      store.dispatch("handleErrors", {
        errors: [
          {
            field: "twilio",
            message: error.response.data.message
          }
        ]
      });
    } else if (error.response.statusText === "Unauthorized") {
      store.dispatch("handleErrors", {
        errors: [
          {
            field: error.response.data[0] && error.response.data[0].field,
            message: error.response.data[0] && error.response.data[0].message
          }
        ]
      });
    } else if (error.response.data.type === "validation") {
      store.dispatch("handleErrors", { errors: error.response.data.errors });
    } else if (error.response.data.message === "This Kit ID already exists") {
      store.dispatch("handleErrors", {
        errors: [
          {
            field: "kit_dashboard",
            message: "This Kit ID already exists"
          }
        ]
      });
    }
    return Promise.reject(error);
  }
);

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

const store = new Vuex.Store({
  modules: {
    registration,
    profile,
    login,
    admin,
    adminsub,
    wckits,
    wooAnalytics
  }
});
export default store;
